import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { login } from "../actions/accountActions";
import { getCart, saveCart } from "../actions/cartActions";
import FormField from "../components/FormField";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { required, length } from 'redux-form-validators'
import { withTranslation } from 'react-i18next';
import ExtendedLink from "../components/ExtendedLink";
import NearbyConsultants from "./NearbyConsultants";


class LoginForm extends Component {


    state = {
        isNearbyConsultantsPopUp: false,
        showPassword: false
    }

    togglePasswordVisibility = (e) => {
        e.preventDefault(); 
        this.setState(prevState => ({
            showPassword: !prevState.showPassword
        }));
    };

    onLoginHandler(values) {
        return this.props.login(values).then((response) => {
            //console.log(response)
            const user = response && response.value ? response.value.data : this.props.user;
            if (user.isAuthenticated === true) {
                this.props.getCart(user.userId, null, true).then((response) => {
                    // console.log(response)
                    const { cart } = this.props;
                    if (cart.saveAfterCartMerge === true) {
                        this.props.saveCart(cart);
                    }
                }, (error) => { });
            }
        }, (error) => { });
    }

    onContactNearbyConsultantHandler(e) {
        // e.preventDefault();
        // this.props.history.push('/nearby-consultants')

        this.setState({
            isNearbyConsultantsPopUp: true
        })
    }

    onCloseNearbyConsultantsPopUp(e) {
        e.preventDefault();
        this.setState({
            isNearbyConsultantsPopUp: false
        })
    }

    render() {
        const { t, handleSubmit, user, settings } = this.props;
        const showNearbyConsultants = settings.allowRegister == false && settings.isPersonalisedSite !== true;
        if (user.isAuthenticated) {
            return <Redirect to={`${settings.baseUrl}`} />;
        }

        return (
            <div className="row padding-top-3x d-flex justify-content-center">
                <div className="login-box-container">
                    <div className="w-550 mr-md-4">
                        <form
                            className="login-box"
                            method="post"
                            onSubmit={handleSubmit(this.onLoginHandler.bind(this))}>
                            <Field
                                className="form-control"
                                type="search"
                                name="username"
                                icon="icon-head"
                                autoComplete="off"
                                component={FormField}
                                placeholder={t("email/username")}
                                validate={[required({ msg: t("is required") })]}
                            />
                            <div style={{ position: "relative" }}>
                            <Field
                                className="form-control"
                                type={this.state.showPassword ? "text" : "password"}
                                name="password"
                                icon="icon-lock"
                                component={FormField}
                                placeholder={t("Password")}
                                validate={[
                                    required({ msg: t("is required") }),
                                    length({ min: 3, msg: t('is too short (min is {count, number} characters)') })
                                ]}
                            />

                            {/* EYE ICON */}
                            <span
                                onClick={this.togglePasswordVisibility}
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    zIndex: 10,
                                    pointerEvents: "auto"
                                }}
                            >
                                <i className={this.state.showPassword ? "icon-eye" : "icon-eye"} />
                            </span>
                        </div>

                        
                            <div className="d-flex flex-wrap justify-content-between padding-bottom-1x">
                                <div className="custom-control custom-checkbox">
                                    <input
                                        className="custom-control-input"
                                        type="checkbox"
                                        id="remember_me"
                                        defaultChecked
                                    />
                                    <label className="custom-control-label" htmlFor="remember_me">
                                        {t("Remember me")}
                                    </label>
                                </div>
                                <ExtendedLink className="navi-link" to={`${settings.baseUrl}forgot-password`}>
                                    {t("Forgot password?")}
                                </ExtendedLink>
                            </div>
                            <div className="text-center text-sm-right">
                                <button
                                    className="btn btn-primary margin-bottom-none"
                                    type="submit">
                                    {t("Login")}
                                </button>
                            </div>
                        </form>
                    </div>
                    {!showNearbyConsultants && <div className="w-300 mt-1">
                        <div className="padding-top-3x hidden-md-up"></div>
                        <h3 className="margin-bottom-1x">{t("No Account?")}</h3><ExtendedLink className="btn btn-primary" to={`${settings.baseUrl}register`}> {t("Register")} </ExtendedLink>
                        <p> {t("Registration takes less than a minute but gives you full control over your orders.")}</p>
                    </div>}
                    {/* allowRegister setting flag is used as an indicator to differentiate between normal suppliers register flow and other suppliers nearby consultant registiration flow */}
                    {showNearbyConsultants &&
                        <div className="w-400 mt-1">
                            <div className="padding-top-3x hidden-md-up"></div>
                            <h3 className="margin-bottom-1x">{t("No Account?")}</h3>
                            {/* {!this.state.isNearbyConsultantsPopUp &&
                        <Fragment>
                            <a className="btn btn-primary" onClick={(e) => this.onContactNearbyConsultantHandler(e) }>{t("Find Your Consultant")}</a>
                            <p> {t("If you have no account yet, simply get in touch with one of our consultants.")}</p>
                        </Fragment>
                        } */}
                            {/* {this.state.isNearbyConsultantsPopUp &&
                            <NearbyConsultants></NearbyConsultants>
                        } */}
                            <NearbyConsultants></NearbyConsultants>
                        </div>}

                </div>
            </div>
        );
    }
}

function mapStateToProps({ user, settings, cart }, ownProps) {
    return { user, settings, cart, ...ownProps };
}

LoginForm = connect(mapStateToProps, { login, getCart, saveCart })(LoginForm);

export default withTranslation()(withRouter(reduxForm({
    form: "login"
})(LoginForm)));
